import { audioExtensions, image3DExtensions, imageExtensions, videoExtensions } from 'utils/constants'
import { notifyToast } from './responseUtils'

export function sliderValueToVideoTime(duration, sliderValue) {
  return Math.round((duration * sliderValue) / 100)
}

export const getMediaType = (media) => {
  const ext = media.split('.').pop()
  if (videoExtensions.includes(ext)) return 'video'
  else if (audioExtensions.includes(ext)) return 'audio'
  else return 'image'
}

export const compareExtWithFileType = (fileTypes, media) => {
  const ext = media.split('.').pop()
  if (imageExtensions.includes(ext)) return fileTypes.includes('Image')
  if (videoExtensions.includes(ext)) return fileTypes.includes('Video')
  else if (audioExtensions.includes(ext)) return fileTypes.includes('Audio')
  else if (image3DExtensions.includes(ext)) return fileTypes.includes('3D Image')
  else if (ext === 'json') return fileTypes.includes('JSON')
  return false
}

export const defaultImage = 'https://styley.ai/gpu/def_icon.png'

export const copyToClipboard =
  (data, custom = null) =>
  (dispatch) => {
    navigator.clipboard.writeText(data).then(
      () => {
        dispatch(notifyToast('success', custom || 'Media URL is copied successfully!'))
      },
      () => {
        console.error('Failed to copy')
        /* Rejected - text failed to copy to the clipboard */
      }
    )
  }

export const videoThumbnail = (video) => {
  return video
  // return `https://compy.mediamagic.ai/gpu/preview/preview_vid.r.php?video=${video}&w=640`
}

export const videoOptimized = (video) => {
  return video
  // return `https://compy.mediamagic.ai/gpu/preview/preview_vid.c.php?video=${video}&w=640`
}

export const image3dOptimized = (url) => {
  return url
  // return `https://compy.mediamagic.ai/gpu/preview/3d.php?object=${url}`
}
